import { jsxs as i, jsx as s } from "react/jsx-runtime";
import { f as y, E as P, F as h, G as v } from "../../vendor--aJiswR_.js";
import { Fragment as O } from "react";
import { getSpacingClasses as F } from "../../utils/getSpacingClasses/index.js";
import { omitStyleRenderProps as T } from "../../utils/omitStyleRenderProps/index.js";
import { BaseIcon as j } from "../BaseIcon/index.js";
import { TooltipTrigger as E, Tooltip as S } from "../Tooltip/index.js";
import '../../assets/index20.css';const z = "_pill_15n0f_1", B = "_iconOnly_15n0f_11", C = "_moon_15n0f_15", G = "_teal_15n0f_25", I = "_green_15n0f_35", N = "_cactus_15n0f_45", R = "_gold_15n0f_55", W = "_sienna_15n0f_65", k = "_red_15n0f_75", q = "_magenta_15n0f_85", w = "_purple_15n0f_95", A = "_blue_15n0f_105", t = {
  pill: z,
  iconOnly: B,
  moon: C,
  teal: G,
  green: I,
  cactus: N,
  gold: R,
  sienna: W,
  red: k,
  magenta: q,
  purple: w,
  blue: A
};
function U({
  textValue: o,
  tooltip: c,
  icon: r,
  color: l = "teal",
  m: a,
  mt: f,
  mr: _,
  ml: p,
  mb: m,
  ...e
}) {
  const d = y(
    t[l],
    t.pill,
    !o && t.iconOnly,
    F({ m: a, mt: f, mr: _, ml: p, mb: m })
  ), { focusProps: g, isFocusVisible: u } = P(e), n = c?.children, b = n ? v : O, $ = n ? "button" : "span", x = n ? h(e, g, {
    "data-focus-visible": u || void 0,
    "aria-disabled": !0
  }) : e;
  return /* @__PURE__ */ i(E, { children: [
    /* @__PURE__ */ s(b, { children: /* @__PURE__ */ i($, { ...T(x), className: d, "data-component": "Pill", children: [
      r && /* @__PURE__ */ s(j, { color: l, icon: r, size: "xs", mr: o ? 2 : 0 }),
      o
    ] }) }),
    n && /* @__PURE__ */ s(S, { ...c })
  ] });
}
export {
  U as Pill
};
//# sourceMappingURL=index.js.map
